import { render, staticRenderFns } from "./RolesTable.vue?vue&type=template&id=61c81534"
import script from "./RolesTable.js?vue&type=script&lang=js&external"
export * from "./RolesTable.js?vue&type=script&lang=js&external"
import style0 from "./RolesTable.vue?vue&type=style&index=0&id=61c81534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports